import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ThemeProvider } from 'styled-components';
import '@frete.com/fuel-fonts/satoshi/fontface.css';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import TruckerList from 'components/TruckerList';
import { AppContextProvider } from 'context';
import { ToastProvider } from 'context/ToastProvider';
import GlobalStyle from '../global.styles';

const queryClient = new QueryClient();

export const TruckerListing: FC = () => {
  const fallbackRender = (): JSX.Element => null;

  return (
    <AppContextProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={dsTokens}>
          <ErrorBoundary fallbackRender={fallbackRender}>
            <Outlet />
            <GlobalStyle />
            <ToastProvider>
              <TruckerList />
            </ToastProvider>
            <div className="portal-trucker-listing" />
          </ErrorBoundary>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default TruckerListing;
